import './App.css';
import Header from './components/Header';
import Home from './components/Home'
import About from './components/About'
import Product from './components/Product'
import Contact from './components/Contact'
import { Redirect, Route, Switch } from 'react-router-dom';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';
import Checkout from './components/Checkout'
import Footer from './components/Footer'
import PaymentSuccess from './components/PaymentSuccess'
import ProductNike from './components/ProductNike'
import ProductsAdidas from './components/ProductAdidas'



function App() {
  return (
    <>
    <style>{'body { background-color: white; }'}</style>
      <Header/>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/products" component={Product} />
        <Route exact path="/products/:id" component={ProductDetail} />
        <Route exact path="/cart" component={Cart} />
        <Route exact path="/checkout" component={Checkout} />
        <Route exact path="/about" component={About} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/PaymentSuccess" component={PaymentSuccess} />
        <Route exact path="/productsNike" component={ProductNike} />
        <Route exact path="/productsAdidas" component={ProductsAdidas} />
        <Redirect to="/" />
      </Switch>
      <Footer/>
    </>
  );
}

export default App;
